type SortableAlert = { createdAt: string }

export const sortAlertsBy = (key: 'createdAt') => {
  return (a: SortableAlert, b: SortableAlert) => {
    if (a[key] > b[key]) return -1
    if (b[key] > a[key]) return 1
    return 0
  }
}
